module.exports = __webpack_public_path__ + "img/08.ac86dbeb.jpg";